import pathOr from 'ramda/src/pathOr';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { EMPTY_ARRAY, EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { UOM_CATEGORIES } from '../../../src/customercare.constants';
import { SelectedServiceDetailsSelector } from '../../reducers/selectors/selected.service.details.selectors';
var EditPolicyCounterModalStoreSelector = function EditPolicyCounterModalStoreSelector(state) {
  return state.customercare.editPolicyCounterModal;
};
export var IsLoadingSelector = createImmutableSelector([EditPolicyCounterModalStoreSelector], function (editPolicyCounterModalStore) {
  return editPolicyCounterModalStore.isLoading;
});
export var PolicyCountersSelector = createImmutableSelector([SelectedServiceDetailsSelector], function (selectedServiceDetails) {
  return pathOr(EMPTY_ARRAY, ['PolicyCounters'], selectedServiceDetails);
});
export var SelectedPolicyCounterSelector = createImmutableSelector([EditPolicyCounterModalStoreSelector], function (store) {
  return store.selectedPolicyCounter || EMPTY_OBJECT;
});
export var UnitOfMeasuresSelector = createImmutableSelector([MetadataCodeTypeDictionarySelector(CODES.UnitsOfMeasure), SelectedPolicyCounterSelector], function (unitOfMeasures, selectedPolicyCounter) {
  var _Object$values, _Object$values$find, _Object$values$find$A;
  var unitOfMeasuresOptions = [{
    label: i18n.translate(CoreLocaleKeys.SELECT),
    value: null
  }];
  var selectedPolicyCounterUomCategory = (_Object$values = Object.values(unitOfMeasures)) === null || _Object$values === void 0 ? void 0 : (_Object$values$find = _Object$values.find(function (unitOfMeasure) {
    return selectedPolicyCounter.BalanceUnitCode === unitOfMeasure.Value;
  })) === null || _Object$values$find === void 0 ? void 0 : (_Object$values$find$A = _Object$values$find.AdditionalProperties) === null || _Object$values$find$A === void 0 ? void 0 : _Object$values$find$A.category;
  return Object.keys(unitOfMeasures).length && selectedPolicyCounterUomCategory ? unitOfMeasuresOptions.concat(Object.values(unitOfMeasures).filter(function (uom) {
    if (selectedPolicyCounterUomCategory === UOM_CATEGORIES.DATA_UNIVERSAL) {
      return uom.AdditionalProperties.category.includes('Data');
    } else if (selectedPolicyCounterUomCategory === UOM_CATEGORIES.DATA_IT || selectedPolicyCounterUomCategory === UOM_CATEGORIES.DATA_SCIENTIFIC || selectedPolicyCounterUomCategory === UOM_CATEGORIES.DATA_TELCO) {
      return uom.AdditionalProperties.category === selectedPolicyCounterUomCategory || uom.AdditionalProperties.category === UOM_CATEGORIES.DATA_UNIVERSAL;
    } else {
      return uom.AdditionalProperties.category === selectedPolicyCounterUomCategory;
    }
  }).map(function (unit) {
    return {
      label: selectedPolicyCounterUomCategory === UOM_CATEGORIES.DATA_UNIVERSAL ? "".concat(unit.AdditionalProperties.short_name, "\xA0\xA0").concat(unit.Description) : unit.AdditionalProperties.short_name,
      value: convertStringToNumber(unit.Value)
    };
  })) : EMPTY_ARRAY;
});